import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingCart, XCircle } from "lucide-react";
import { useCart } from "@/context/CartContext";
import Reveal from "@/components/Reveal";

export default function PaymentCancel() {
  const { count, setIsOpen } = useCart();
  return (
    <main className="mx-auto flex max-w-xl flex-col items-center gap-6 px-5 pb-24 pt-40 text-center" data-testid="payment-cancel-page">
      <Reveal>
        <XCircle size={52} className="text-voltaic-amber" />
        <h1 className="mt-6 font-display text-3xl font-extrabold uppercase tracking-tight">Payment cancelled</h1>
        <p className="mt-3 text-voltaic-muted">
          No charge was made. Your cart is still fully loaded{count > 0 ? ` with ${count} item${count === 1 ? "" : "s"}` : ""}.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/shop" data-testid="cancel-shop-link" className="flex items-center gap-2 rounded-full bg-voltaic-cyan px-7 py-3 font-semibold text-voltaic-bg hover:glow-cyan">
            <ArrowLeft size={16} /> Back to catalogue
          </Link>
          {count > 0 && (
            <button
              data-testid="cancel-cart-button"
              onClick={() => setIsOpen(true)}
              className="flex items-center gap-2 rounded-full border border-voltaic-linebright px-7 py-3 font-semibold transition-colors hover:border-voltaic-cyan hover:text-voltaic-cyan"
            >
              <ShoppingCart size={16} /> Review cart
            </button>
          )}
        </div>
      </Reveal>
    </main>
  );
}
